import AdsContainer from "../../../../app/utils/AdsContainer.tsx";
import {useSelector} from "react-redux";
import {RootState} from "../../../../app/core/store/store.ts";

const Footer = () => {
  const advertising = useSelector((state: RootState) => state.advertising)

  return (
    <>
      <AdsContainer
        size={120}
        ads={advertising.bottom}
      />
    </>
  )
}

export {Footer}
